<template>
  <div>
    <div class="bread-crumbs-box">
      <Breadcrumb
        separator="»"
        class="bread-crumbs"
        style="width: 1200px; margin: 0 auto"
      >
        <Breadcrumb-item class="breadcrumb-item" to="/">首页</Breadcrumb-item>
        <Breadcrumb-item class="breadcrumb-item-last">{{
          name
        }}</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="container clearfix">
      <div class="article-sider">
        <div class="article-info-bar">{{ name }}</div>
        <div class="article-list">
          <router-link
            :to="{
              name: 'NewsTopicParam',
              params: { id: item.id },
              query: { m: m },
            }"
            v-for="(item, index) in articleList"
            :key="index"
            >{{ item.title }}</router-link
          >
        </div>
      </div>
      <div class="article-detail">
        <h1>{{ articleInfo.title }}</h1>
        <div class="article-info" v-html="articleInfo.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { article } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      m: "",
      name: "",
      articleList: [],
      articleInfo: {},
    };
  },
  mounted() {
    this.initParam();
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  methods: {
    initParam() {
      this.name = this.$route.query.n;
      this.m = this.$route.query.m;
      if (!this.m) return;
      this.getData();
    },
    getData() {
      this.id = this.$route.params.id;
      article
        .getTopicArticleList(this.m, this.siteConfig.agencyId)
        .then((res) => {
          if (res.status === 1) {
            this.articleList = res.data.articles;
            if (this.id) {
              this.articleInfo = this.articleList.find((m) => m.id == this.id);
            } else if (this.articleList && this.articleList.length > 0) {
              this.articleInfo = this.articleList[0];
            }
          }
          // console.log("talist", res);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.bread-crumbs-box {
  background: #fff;
  .bread-crumbs {
    height: 48px;
    line-height: 48px;
    background: #fff;
    .breadcrumb-item {
      color: #0e90d2;
      font-size: 15px;
    }
    .breadcrumb-item-last {
      color: #999;
      font-size: 15px;
    }
  }
}
.container {
  display: flex;
  padding: 32px 0;
}
// 通用标题
.article-info-bar {
  width: 200px;
  height: 40px;
  line-height: 40px;
  background: url("../../assets/images/v3/product-detail-title.png") no-repeat
    left center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-indent: 1em;
}
.article-sider {
  width: 300px;
  background: #fff;
  padding: 16px 0;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  .article-list {
    margin-top: 16px;
    a {
      display: block;
      padding: 8px 16px;
      margin: 4px 0;
      &.selected,
      &:hover {
        background: #f5f5f5;
      }
    }
  }
}
.article-detail {
  flex: 1;
  background: white;
  margin-left: 32px;
  padding: 20px 30px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
  h1 {
    text-align: center;
    font-size: 26px;
  }
  .article-info {
    margin-top: 20px;
  }
}
.article-info {
  /deep/img {
    display: inline-block;
  }
}
.am-text-center {
  text-align: center;
}
.am-text-lg {
  font-size: 1.8rem;
}
.am-margin-bottom {
  margin-bottom: 1.6rem;
}
</style>
